import { useContext } from "react"
import { FilterContext } from "src/contexts/FilterProvider"

const useFilter = () => {
  return useContext(FilterContext)
}

export default useFilter
